import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import PAGES from "routes/constants";
import useCommonStore from "stores/useCommon";

// Id the upload flow redirects to (/dashboard/NOT_FOUND_IN_PDF) when no ref ADEME was found in the PDF
export const NOT_FOUND_IN_PDF = "NOT_FOUND_IN_PDF";

function NotFoundInPdf() {
  const navigate = useNavigate();
  const { setIsLoadedPage } = useCommonStore();

  useEffect(() => {
    setIsLoadedPage(true);
  }, [setIsLoadedPage]);

  const handleBack = () => {
    // Back to the previous page (upload) when there is one in history, else straight to upload
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(PAGES.upload);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <Result
        status="warning"
        title={
          <span className="text-2xl md:text-4xl font-bold">
            Numéro ADEME introuvable dans le PDF
          </span>
        }
        subTitle={
          <span className="text-base md:text-lg">
            Nous n'avons pas pu trouver de numéro ADEME dans le document
            envoyé. Vérifiez qu'il s'agit bien d'un DPE, puis réessayez avec un
            autre fichier.
          </span>
        }
        extra={
          <Button
            type="primary"
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
          >
            Retour à l'envoi du PDF
          </Button>
        }
      />
    </div>
  );
}

export default NotFoundInPdf;
